module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAB2SURBVFiF7daxCYBADAXQH3EQG0G3cAldT2tdwi0uwgluEmvtcgSu+b8M/ONBUpygIKr3DrP5O7VjGPvF+1ZTAogMAQQQQAAB1QFypbx6SwZMALrf+BHgdAM0ZfOWIlN9BQS0AmzeUugRegvgl4wAAggggIDgvLaxHZXxzeqJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-upload/images/plus-gray.png
// module id = B74i
// module chunks = 4